import { useNavigate } from 'react-router-dom';
import { Category } from '../../../types/Category';

export const useCategoriesNavigation = (onNavigate?: () => void) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    onNavigate?.();
  };

  const handleCategoryClick = (category: Category) => {
    const path = `categoria/${category.sku}`;
    handleNavigation(path);
  };

  const handleViewAllInCategory = (category: Category) => {
    const path = `categoria/${category.sku}`;
    handleNavigation(path);
  };

  return {
    handleNavigation,
    handleCategoryClick,
    handleViewAllInCategory,
  };
};














